export const CONTRACT_STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "pending_signature", label: "Pending Signature" },
  { value: "pending_documents", label: "Pending Documents" },
  { value: "ready_to_activate", label: "Ready To Activate" },
  { value: "active", label: "Active" },
  { value: "suspended", label: "Suspended" },
  { value: "terminated", label: "Terminated" },
  { value: "cancelled", label: "Cancelled" },
];

export const CONTRACT_PERIODICITY_OPTIONS = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "yearly", label: "Yearly" },
];

export const createDefaultContractForm = () => ({
  contract_number: "",
  plan_id: "",
  status: "draft",
  currency: "EUR",
  start_date: "",
  signature_date: "",
  renewal_date: "",
  periodicity: "monthly",
  auto_renew: true,
  notes: "",
  internal_note: "",
});

export const toInputDate = (value) => {
  if (!value) return "";
  const text = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return text;
  if (/^\d{4}-\d{2}-\d{2}[T\s]/.test(text)) return text.slice(0, 10);
  return "";
};

export const mapContractRowToForm = (row) => ({
  contract_number: row?.contract_number || "",
  plan_id: row?.plan_id || "",
  status: row?.status || "draft",
  currency: row?.currency || "EUR",
  start_date: toInputDate(row?.start_date),
  signature_date: toInputDate(row?.signature_date),
  renewal_date: toInputDate(row?.renewal_date),
  periodicity: row?.periodicity || "monthly",
  auto_renew: Boolean(row?.auto_renew),
  notes: row?.notes || "",
  internal_note: row?.internal_note || "",
});

export const buildContractPayload = (form, userId) => ({
  ...form,
  user_id: userId,
  signature_date: form.signature_date || null,
  renewal_date: form.renewal_date || null,
  notes: form.notes || null,
  internal_note: form.internal_note || null,
});

